"use client";

import React from "react";
import { Download, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheUniversalMetaRuntime() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221782" id="manteniment-de-lentorn-rural" className="text-foreground relative overflow-hidden min-h-[95vh] flex flex-col items-center justify-center pt-24 pb-16 bg-background bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651626/img/rural_landscape.png)]">
      <div className="absolute inset-0 bg-black/60 z-0"></div>
      
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,var(--color-secondary)_0%,transparent_70%)] opacity-10"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_60%)] opacity-5 blur-[120px]"></div>
      </div>

      <div ref={ref} className={`container relative z-10 mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        
        <h1 className="font-default text-5xl md:text-7xl lg:text-8xl leading-[1.1] font-bold tracking-tighter mb-8 text-secondary max-w-5xl drop-shadow-2xl">
          Salvat Serveis Rurals
        </h1>

        <div className="text-lg md:text-xl lg:text-2xl text-secondary/90 max-w-3xl mb-12 font-default font-normal leading-relaxed space-y-4">
          <p>A Salvat Serveis Rurals treballem per mantenir finques, terrenys i camins rurals en bon estat.</p>
          <p>Oferim serveis professionals de desbrossament, poda i neteja de terrenys, parcel·les i manteniment de camins privats per a particulars, empreses, propietaris de finques i administració.</p>
          <p>Ens adaptem a les necessitats de cada client amb un treball seriós, eficient i respectuós amb l’entorn. Realitzem treballs a tot Catalunya, per totes les comarques de Barcelona, Girona, Tarragona i Lleida (a consultar pirineu Lleidetà).<br /><br />"SOM ALLÀ ON ENS NECESSITIS"<br /></p>
        </div>

        <div className="flex flex-wrap flex-col sm:flex-row gap-5 w-full sm:w-auto items-center justify-center">
          <Link to="#contacte" className="w-full sm:w-auto group">
            
          </Link>
          
          <Link to="#" className="w-full sm:w-auto group">
            
          </Link>
        </div>

        <div className="mt-12 flex items-center gap-6 text-secondary/60 text-sm font-medium tracking-wider uppercase">
          
          <span className="w-1 h-1 rounded-full bg-secondary/30"></span>
          
          <span className="w-1 h-1 rounded-full bg-secondary/30"></span>
          
        </div>
      </div>
    </section>;
}